"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderSubscriberReduction = exports.getOrderPrice = void 0;
var Order_1 = require("../../Enums/Order");
var getOrderPrice = function (order, priceCategory) {
    if (priceCategory)
        return order[priceCategory];
    return order[order.priceCategory];
};
exports.getOrderPrice = getOrderPrice;
var getOrderSubscriberReduction = function (order) {
    var publicPrice = parseFloat((0, exports.getOrderPrice)(order, Order_1.PriceCategory.priceOneShot).subTotal) || 0;
    var subscriptionPrice = parseFloat((0, exports.getOrderPrice)(order, Order_1.PriceCategory.priceSubscription).subTotal) || 0;
    return publicPrice - subscriptionPrice;
};
exports.getOrderSubscriberReduction = getOrderSubscriberReduction;
exports.default = { getOrderPrice: exports.getOrderPrice, getOrderSubscriberReduction: exports.getOrderSubscriberReduction };
//# sourceMappingURL=OrderPrices.js.map